import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import './App.css';
import Home from './pages/Home';

function App() {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#0071e3',
          colorLink: '#0066cc',
          colorSuccess: '#30d158',
          colorWarning: '#ff9f0a',
          colorError: '#ff453a',
          colorText: '#1d1d1f',
          colorTextSecondary: '#6e6e73',
          colorBorder: '#d2d2d7',
          colorBgContainer: '#ffffff',
          colorBgLayout: '#f5f5f7',
          borderRadius: 8,
          fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', Roboto, sans-serif",
          fontSize: 17,
          lineHeight: 1.47,
        },
        components: {
          Button: {
            primaryShadow: '0 1px 2px rgba(0, 0, 0, 0.08)',
            fontWeight: 600,
            controlHeightLG: 48,
          },
          Card: {
            headerFontSize: 17,
          },
          Input: {
            activeBorderColor: '#0071e3',
            hoverBorderColor: '#86868b',
            controlHeightLG: 48,
          },
        },
      }}
    >
      <Home />
    </ConfigProvider>
  );
}

export default App;
